{
  "myWork": {
    "title": "My Work",
    "description": "Action items for you and your team in {{module}}",
    "approvalsLink": "Approvals →",
    "executiveLink": "Executive view →",
    "scope": "Scope",
    "priority": "Priority",
    "scopeMyTeam": "My team",
    "scopeAssignedToMe": "Assigned to me",
    "priorityAny": "Any priority",
    "priorityCritical": "Critical",
    "priorityHigh": "High",
    "priorityMedium": "Medium",
    "priorityLow": "Low",
    "bucketAll": "All open",
    "bucketAttention": "Needs attention",
    "bucketDueToday": "Due today",
    "bucketOverdue": "Overdue",
    "bucketAwaitingApproval": "Awaiting approval",
    "bucketAwaitingResponse": "Awaiting response",
    "kpiAttention": "Needs attention",
    "kpiOverdue": "Overdue",
    "kpiAwaitingApproval": "Awaiting approval",
    "kpiAssignedToMe": "Assigned to me",
    "sectionOpen": "Open items",
    "empty": "No items in this bucket",
    "sectionWorkItems": "Work items",
    "sectionWorkItemsDesc": "Only items for you and employees in your reporting scope",
    "sectionSuggestions": "Suggestions",
    "viewLink": "View →",
    "loading": "Loading…",
    "emptyFilters": "No items match your filters. You only see work for yourself and employees in your hierarchy."
  },
  "toast": {},
  "errors": {
    "notificationActionFailed": "Notification action failed",
    "failedToMarkNotificationRead": "Failed to mark notification read",
    "failedToLoadWorkQueue": "Failed to load work queue"
  },
  "pages": {
    "dueToday": "Due today",
    "overdue": "Overdue",
    "approvals": "Approvals",
    "assignedToMe": "Assigned to me",
    "executiveCommandCenter": "Executive Command Center",
    "executiveDescription": "Business-critical risks and alerts in {{module}}",
    "executiveEmpty": "No critical executive alerts right now.",
    "investigateLink": "Investigate →",
    "criticalRisks": "Critical risks",
    "criticalWorkQueue": "Critical work queue",
    "notifications": "Notifications"
  },
  "card": {
    "employee": "Employee",
    "status": "Status",
    "due": "Due",
    "open": "Open",
    "bucketUpcoming": "Upcoming",
    "bucketCompleted": "Completed",
    "actionFailed": "{{action}} failed",
    "priorityInfo": "Info"
  },
  "labels": {}
}
